import { defineComponent as Be, watchEffect as Me, ref as B, toRef as Ne, watch as Te, computed as Pe, h as d, nextTick as Se } from "vue";
import { parseNumber as H, validator as L, format as X, isWipValue as De, parse as Oe } from "./ghl-ui.es1036.js";
import Ce from "./ghl-ui.es1037.js";
import { useRtl as Fe } from "./ghl-ui.es851.js";
import { warnOnce as Ae } from "./ghl-ui.es853.js";
import Ue from "./ghl-ui.es854.js";
import ne from "./ghl-ui.es855.js";
import _e from "./ghl-ui.es919.js";
import Ee from "./ghl-ui.es870.js";
import ke from "./ghl-ui.es712.js";
import h from "./ghl-ui.es706.js";
import { rgba as $e } from "./ghl-ui.es904.js";
import He from "./ghl-ui.es182.js";
import { resolveWrappedSlot as q, resolveSlot as J } from "./ghl-ui.es860.js";
import Le from "./ghl-ui.es1038.js";
import { on as Q } from "./ghl-ui.es710.js";
import { XButton as Y } from "./ghl-ui.es253.js";
import Z from "./ghl-ui.es862.js";
import je from "./ghl-ui.es1039.js";
import ze from "./ghl-ui.es1003.js";
import { call as I } from "./ghl-ui.es876.js";
const ee = 800, te = 100, Ge = Object.assign(Object.assign({}, ne.props), {
  autofocus: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  defaultValue: {
    type: Number,
    default: null
  },
  value: Number,
  step: {
    type: [Number, String],
    default: 1
  },
  min: [Number, String],
  max: [Number, String],
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  validator: Function,
  bordered: {
    type: Boolean,
    default: void 0
  },
  showButton: {
    type: Boolean,
    default: !0
  },
  buttonPlacement: {
    type: String,
    default: "right"
  },
  inputProps: Object,
  readonly: Boolean,
  clearable: Boolean,
  keyboard: {
    type: Object,
    default: {}
  },
  updateValueOnInput: {
    type: Boolean,
    default: !0
  },
  parse: Function,
  format: Function,
  precision: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  // deprecated
  onChange: [Function, Array]
}), mt = Be({
  name: "InputNumber",
  props: Ge,
  setup(n) {
    process.env.NODE_ENV !== "production" && Me(() => {
      n.onChange !== void 0 && Ae("input-number", "`on-change` is deprecated, please use `on-update:value` instead");
    });
    const {
      mergedBorderedRef: i,
      mergedClsPrefixRef: g,
      mergedRtlRef: S
    } = Ue(n), u = ne("InputNumber", "-input-number", Ce, Le, n, g), {
      localeRef: v
    } = _e("InputNumber"), M = Ee(n), {
      mergedSizeRef: re,
      mergedDisabledRef: le,
      mergedStatusRef: ie
    } = M, s = B(null), j = B(null), z = B(null), D = B(n.defaultValue), ue = Ne(n, "value"), f = ke(ue, D), p = B(""), O = (e) => {
      const t = String(e).split(".")[1];
      return t ? t.length : 0;
    }, ae = (e) => {
      const t = [n.min, n.max, n.step, e].map((r) => r === void 0 ? 0 : O(r));
      return Math.max(...t);
    }, oe = h(() => {
      const {
        placeholder: e
      } = n;
      return e !== void 0 ? e : v.value.placeholder;
    }), N = h(() => {
      const e = H(n.step);
      return e !== null ? e === 0 ? 1 : Math.abs(e) : 1;
    }), G = h(() => {
      const e = H(n.min);
      return e !== null ? e : null;
    }), K = h(() => {
      const e = H(n.max);
      return e !== null ? e : null;
    }), V = (e) => {
      const {
        value: t
      } = f;
      if (e === t) {
        b();
        return;
      }
      const {
        "onUpdate:value": r,
        onUpdateValue: l,
        onChange: o
      } = n, {
        nTriggerFormInput: c,
        nTriggerFormChange: x
      } = M;
      o && I(o, e), l && I(l, e), r && I(r, e), D.value = e, c(), x();
    }, a = ({
      offset: e,
      doUpdateIfValid: t,
      fixPrecision: r,
      isInputing: l
    }) => {
      const {
        value: o
      } = p;
      if (l && De(o))
        return !1;
      const c = (n.parse || Oe)(o);
      if (c === null)
        return t && V(null), null;
      if (L(c)) {
        const x = O(c), {
          precision: R
        } = n;
        if (R !== void 0 && R < x && !r)
          return !1;
        let m = parseFloat((c + e).toFixed(R ?? ae(c)));
        if (L(m)) {
          const {
            value: k
          } = K, {
            value: $
          } = G;
          if (k !== null && m > k) {
            if (!t || l)
              return !1;
            m = k;
          }
          if ($ !== null && m < $) {
            if (!t || l)
              return !1;
            m = $;
          }
          return n.validator && !n.validator(m) ? !1 : (t && V(m), m);
        }
      }
      return !1;
    }, b = () => {
      const {
        value: e
      } = f;
      if (L(e)) {
        const {
          format: t,
          precision: r
        } = n;
        t ? p.value = t(e) : e === null || r === void 0 || // precision overflow
        O(e) > r ? p.value = X(e, void 0) : p.value = X(e, r);
      } else
        p.value = String(e);
    };
    b();
    const de = h(() => a({
      offset: 0,
      doUpdateIfValid: !1,
      isInputing: !1,
      fixPrecision: !1
    }) === !1), C = h(() => {
      const {
        value: e
      } = f;
      if (n.validator && e === null)
        return !1;
      const {
        value: t
      } = N;
      return a({
        offset: -t,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    }), F = h(() => {
      const {
        value: e
      } = f;
      if (n.validator && e === null)
        return !1;
      const {
        value: t
      } = N;
      return a({
        offset: +t,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    });
    function se(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: r
      } = M;
      t && I(t, e), r();
    }
    function fe(e) {
      var t, r;
      if (e.target === ((t = s.value) === null || t === void 0 ? void 0 : t.wrapperElRef))
        return;
      const l = a({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !1,
        fixPrecision: !0
      });
      if (l !== !1) {
        const x = (r = s.value) === null || r === void 0 ? void 0 : r.inputElRef;
        x && (x.value = String(l || "")), f.value === l && b();
      } else
        b();
      const {
        onBlur: o
      } = n, {
        nTriggerFormBlur: c
      } = M;
      o && I(o, e), c(), Se(() => {
        b();
      });
    }
    function ce(e) {
      const {
        onClear: t
      } = n;
      t && I(t, e);
    }
    function A() {
      const {
        value: e
      } = F;
      if (!e) {
        E();
        return;
      }
      const {
        value: t
      } = f;
      if (t === null)
        n.validator || V(W());
      else {
        const {
          value: r
        } = N;
        a({
          offset: r,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    function U() {
      const {
        value: e
      } = C;
      if (!e) {
        _();
        return;
      }
      const {
        value: t
      } = f;
      if (t === null)
        n.validator || V(W());
      else {
        const {
          value: r
        } = N;
        a({
          offset: -r,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    const me = se, ve = fe;
    function W() {
      if (n.validator)
        return null;
      const {
        value: e
      } = G, {
        value: t
      } = K;
      return e !== null ? Math.max(0, e) : t !== null ? Math.min(0, t) : 0;
    }
    function pe(e) {
      ce(e), V(null);
    }
    function he(e) {
      var t, r, l;
      !((t = z.value) === null || t === void 0) && t.$el.contains(e.target) && e.preventDefault(), !((r = j.value) === null || r === void 0) && r.$el.contains(e.target) && e.preventDefault(), (l = s.value) === null || l === void 0 || l.activate();
    }
    let w = null, y = null, T = null;
    function _() {
      T && (window.clearTimeout(T), T = null), w && (window.clearInterval(w), w = null);
    }
    function E() {
      P && (window.clearTimeout(P), P = null), y && (window.clearInterval(y), y = null);
    }
    function ge() {
      _(), T = window.setTimeout(() => {
        w = window.setInterval(() => {
          U();
        }, te);
      }, ee), Q("mouseup", document, _, {
        once: !0
      });
    }
    let P = null;
    function be() {
      E(), P = window.setTimeout(() => {
        y = window.setInterval(() => {
          A();
        }, te);
      }, ee), Q("mouseup", document, E, {
        once: !0
      });
    }
    const xe = () => {
      y || A();
    }, Ie = () => {
      w || U();
    };
    function Ve(e) {
      var t, r;
      if (e.key === "Enter") {
        if (e.target === ((t = s.value) === null || t === void 0 ? void 0 : t.wrapperElRef))
          return;
        a({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && ((r = s.value) === null || r === void 0 || r.deactivate());
      } else if (e.key === "ArrowUp") {
        if (!F.value || n.keyboard.ArrowUp === !1)
          return;
        e.preventDefault(), a({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && A();
      } else if (e.key === "ArrowDown") {
        if (!C.value || n.keyboard.ArrowDown === !1)
          return;
        e.preventDefault(), a({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && U();
      }
    }
    function we(e) {
      p.value = e, n.updateValueOnInput && !n.format && !n.parse && n.precision === void 0 && a({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !0,
        fixPrecision: !1
      });
    }
    Te(f, () => {
      b();
    });
    const ye = {
      focus: () => {
        var e;
        return (e = s.value) === null || e === void 0 ? void 0 : e.focus();
      },
      blur: () => {
        var e;
        return (e = s.value) === null || e === void 0 ? void 0 : e.blur();
      },
      select: () => {
        var e;
        return (e = s.value) === null || e === void 0 ? void 0 : e.select();
      }
    }, Re = Fe("InputNumber", S, g);
    return Object.assign(Object.assign({}, ye), {
      rtlEnabled: Re,
      inputInstRef: s,
      minusButtonInstRef: j,
      addButtonInstRef: z,
      mergedClsPrefix: g,
      mergedBordered: i,
      uncontrolledValue: D,
      mergedValue: f,
      mergedPlaceholder: oe,
      displayedValueInvalid: de,
      mergedSize: re,
      mergedDisabled: le,
      displayedValue: p,
      addable: F,
      minusable: C,
      mergedStatus: ie,
      handleFocus: me,
      handleBlur: ve,
      handleClear: pe,
      handleMouseDown: he,
      handleAddClick: xe,
      handleMinusClick: Ie,
      handleAddMousedown: be,
      handleMinusMousedown: ge,
      handleKeyDown: Ve,
      handleUpdateDisplayedValue: we,
      // theme
      mergedTheme: u,
      inputThemeOverrides: {
        paddingSmall: "0 8px 0 10px",
        paddingMedium: "0 8px 0 12px",
        paddingLarge: "0 8px 0 14px"
      },
      buttonThemeOverrides: Pe(() => {
        const {
          self: {
            iconColorDisabled: e
          }
        } = u.value, [t, r, l, o] = $e(e);
        return {
          textColorTextDisabled: `rgb(${t}, ${r}, ${l})`,
          opacityDisabled: `${o}`
        };
      })
    });
  },
  render() {
    const {
      mergedClsPrefix: n,
      $slots: i
    } = this, g = () => d(Y, {
      text: !0,
      disabled: !this.minusable || this.mergedDisabled || this.readonly,
      focusable: !1,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleMinusClick,
      onMousedown: this.handleMinusMousedown,
      ref: "minusButtonInstRef"
    }, {
      icon: () => J(i["minus-icon"], () => [d(Z, {
        clsPrefix: n
      }, {
        default: () => d(je, null)
      })])
    }), S = () => d(Y, {
      text: !0,
      disabled: !this.addable || this.mergedDisabled || this.readonly,
      focusable: !1,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleAddClick,
      onMousedown: this.handleAddMousedown,
      ref: "addButtonInstRef"
    }, {
      icon: () => J(i["add-icon"], () => [d(Z, {
        clsPrefix: n
      }, {
        default: () => d(ze, null)
      })])
    });
    return d("div", {
      class: [`${n}-input-number`, this.rtlEnabled && `${n}-input-number--rtl`]
    }, d(He, {
      ref: "inputInstRef",
      autofocus: this.autofocus,
      status: this.mergedStatus,
      bordered: this.mergedBordered,
      loading: this.loading,
      value: this.displayedValue,
      onUpdateValue: this.handleUpdateDisplayedValue,
      theme: this.mergedTheme.peers.Input,
      themeOverrides: this.mergedTheme.peerOverrides.Input,
      builtinThemeOverrides: this.inputThemeOverrides,
      size: this.mergedSize,
      placeholder: this.mergedPlaceholder,
      disabled: this.mergedDisabled,
      readonly: this.readonly,
      textDecoration: this.displayedValueInvalid ? "line-through" : void 0,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onClear: this.handleClear,
      clearable: this.clearable,
      inputProps: this.inputProps,
      internalLoadingBeforeSuffix: !0
    }, {
      prefix: () => {
        var u;
        return this.showButton && this.buttonPlacement === "both" ? [g(), q(i.prefix, (v) => v ? d("span", {
          class: `${n}-input-number-prefix`
        }, v) : null)] : (u = i.prefix) === null || u === void 0 ? void 0 : u.call(i);
      },
      suffix: () => {
        var u;
        return this.showButton ? [q(i.suffix, (v) => v ? d("span", {
          class: `${n}-input-number-suffix`
        }, v) : null), this.buttonPlacement === "right" ? g() : null, S()] : (u = i.suffix) === null || u === void 0 ? void 0 : u.call(i);
      }
    }));
  }
});
export {
  mt as default,
  Ge as inputNumberProps
};
